import { useMemo } from 'react'

import { Request, RequestTicket, RequestTicketType } from 'src/types'

function useGetExpenses(
  request: Request,
  listOfTypes: RequestTicketType[] = ['EXPENSE']
): RequestTicket[] {
  const expenses = useMemo(
    () =>
      request.request_tickets.filter(
        ({ active, request_ticket_type, request_ticket_receipts }) =>
          active &&
          listOfTypes.includes(request_ticket_type) &&
          !!request_ticket_receipts.length
      ),
    [request, listOfTypes]
  )

  return expenses
}

export default useGetExpenses
